import { useMemo } from 'react'

import ConversionResultsCell from './ResultsCell'

import { insertIf } from '../../../../../helpers/common'
import { getParsedResultsMetric } from './helpers'

import { listItemsTableColumnsMaxWidth, listItemsTableColumnsMinWidth } from '../../columnsWidth'

import useStyles from '../../styles'

export const useConversionResultsColumns = ({
  items,
  currencySymbol,
  showAdditionalMetrics,
  advancedMetrics,
  showAttributionWindow
}) => {
  const classes = useStyles()

  const firstItemEventType = items[0]?.promoted_object?.custom_event_type

  const hasItemWithRoasGreaterThanZero = items.some(item => {
    const roas = item?.roas || 0
    return roas > 0
  })

  const hasItemWithResultsValue = items.some(item => {
    const parsedResults = getParsedResultsMetric(item.results)
    const { name: resultsName, value } = parsedResults

    return resultsName && value > 0
  })

  return useMemo(() => {
    return [
      ...insertIf(hasItemWithResultsValue, {
        headTitle: 'Results',
        Component: componentData => (
          <ConversionResultsCell
            componentData={componentData}
            currencySymbol={currencySymbol}
            showAttributionWindow={showAttributionWindow}
          />
        ),
        headClassName: classes.valueColumn,
        className: classes.valueColumn,
        style: {
          minWidth: listItemsTableColumnsMinWidth.conversions
        }
      }),
      ...insertIf(showAdditionalMetrics && firstItemEventType !== 'LEAD' && hasItemWithRoasGreaterThanZero, {
        headTitle: 'ROAS',
        Component: ({ roas, conversions_value: conversionsValue }) => {
          return (
            <>
              {roas || '-'}
              {advancedMetrics && conversionsValue && (
                <div className={classes.columnSubText}>{conversionsValue ? `value ${conversionsValue}` : '-'}</div>
              )}
            </>
          )
        },
        headClassName: classes.valueColumn,
        className: classes.valueColumn,
        style: {
          minWidth: listItemsTableColumnsMinWidth.roas,
          maxWidth: listItemsTableColumnsMaxWidth.roas
        }
      })
    ]
  }, [
    hasItemWithResultsValue,
    classes.valueColumn,
    classes.columnSubText,
    showAdditionalMetrics,
    firstItemEventType,
    hasItemWithRoasGreaterThanZero,
    currencySymbol,
    showAttributionWindow,
    advancedMetrics
  ])
}
